import { isRtl } from '@/utils/rtlStyle';
import CustomScrollbars from './CustomScrollbars';

import { addDefaultProps } from './CustomScrollbars/utils';

function Scrollbars({ children = null, forceHeight, ...props }) {
	return (
		<CustomScrollbars {...addDefaultProps({ ...props })} isRTL={isRtl()}>
			{children}
		</CustomScrollbars>
	);
}

export default Scrollbars;
